import gql from "graphql-tag";

export const createChatRoomGql = gql`
  mutation CreateChatRoom($package: ChatRoomInputType!) {
    createChatRoom(package: $package) {
      response
    }
  }
`;

export const sendTextMessageGql = gql`
  mutation SendtextMessage($package: TextMessageInputType!) {
    sendTextMessage(package: $package) {
      response
    }
  }
`;

export const sendInAppMessageGql = gql`
  mutation SendInAppMessage($package: InAppMessageInputType!) {
    sendInAppMessage(package: $package) {
      response
    }
  }
`;

export const getLocationContactsGql = gql`
  query getLocationContacts($locationId: String!) {
    getLocationContacts(locationId: $locationId) {
      edges {
        node {
          locationId
          personId
          role
          email
          phone
          name
          picture
        }
      }
    }
  }
`;

export const getRenterContactsQuery = gql`
  query getRenterContacts($renterId: String!) {
    getRenterContacts(renterId: $renterId) {
      edges {
        node {
          id
          locationId
          personId
          role
          email
          phone
          name
          picture
          isDelete
        }
      }
    }
  }
`;

export const getChatRoomsQuery = gql`
  query {
    getChatRooms {
      edges {
        node {
          id
          creatorId
          locationId
          createdAt
          updatedAt
          isGroup
          listMemberId
          memberId
          name
          preview
        }
      }
    }
  }
`;

export const getChatRoomsByLocationQuery = gql`
  query abc($locationId: String) {
    getChatRooms(locationId: $locationId) {
      edges {
        node {
          id
          creatorId
          locationId
          createdAt
          updatedAt
          isGroup
          listMemberId
          memberId
          name
          preview
        }
      }
    }
  }
`;

export const getChatRoomLogsQuery = gql`
  query getChatRoomLogsRenter($chatRoomId: String!) {
    getChatRoomLogsRenter(chatRoomId: $chatRoomId, last: 20) {
      edges {
        node {
          id
          chatRoomId
          senderId
          body
          media
          signalWireMetaData
          emailMetaData
          messageLabel
          senderPhone
          receiverPhone
          timeStamp
        }
      }
    }
  }
`;

export const getChatRoomLogsManagerQuery = gql`
  query getChatRoomLogsManager($chatRoomId: String!) {
    getChatRoomLogsManager(chatRoomId: $chatRoomId, last: 20) {
      edges {
        node {
          id
          chatRoomId
          senderId
          body
          media
          signalWireMetaData
          emailMetaData
          messageLabel
          senderPhone
          receiverPhone
          timeStamp
        }
      }
    }
  }
`;

export const subscribeChatMembersToChatroomGql = gql`
  mutation subscribeChatMembersToChatroom($chat_room_id: Int!) {
    subscribeChatMembersToChatroom(package: { chatRoomId: $chat_room_id }) {
      response
    }
  }
`;

export const getChatRoomDetailsQuery = gql`
  query getChatRoomDetails($chatRoomId: String!) {
    getChatRoomDetails(chatRoomId: $chatRoomId) {
      edges {
        node {
          id
          name
          role
          picture
          personId
        }
      }
    }
  }
`;

export const getChatLogsByApplicationId = gql`
  query getChatRoomLogsManagerTenantDetail($applicationId: String) {
    getChatRoomLogsManagerTenantDetail(applicationId: $applicationId) {
      edges {
        node {
          id
          chatRoomId
          senderId
          body
          media
          signalWireMetaData
          emailMetaData
          messageLabel
          senderPhone
          receiverPhone
          timeStamp
        }
      }
    }
  }
`;
